import { RouteObject } from "react-router-dom";
import { NotFound } from "src/routes/NotFound";
import { MaterialCatalogPage } from "src/routes/libraries/material-catalog/MaterialCatalogPage";
import { MaterialCostPage } from "src/routes/libraries/material-catalog/MaterialCostPage";
import { MaterialPage } from "src/routes/libraries/material-catalog/MaterialPage";
import { InstallTasksPage } from "src/routes/libraries/material-catalog/install-tasks/InstallTasksPage";
import { MaterialImportPage } from "src/routes/libraries/material-catalog/material-import/MaterialImportPage";
import { MaterialListingPage } from "src/routes/libraries/material-catalog/material-listing-page/MaterialListingPage";
import { MergeMaterialVariantsPage } from "src/routes/libraries/material-catalog/merge-variants/MergeMaterialVariantsPage";
import { AppShell } from "src/routing/components/AppShell";
import { BeamNavbarLayout } from "src/routing/components/layouts/BeamNavbarLayout";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import { WorkflowPageLayout } from "src/routing/components/layouts/WorkflowPageLayout";
import * as materialCatalogPaths from "src/routing/domains/libraries/material-catalog/materialCatalogPaths";

/**
 * `/libraries/material-catalog/*` route tree.
 *
 * Role: data router domain route.
 *
 * Catalog stack: `AppShell` → `BeamNavbarLayout` → page (`PageHeaderLayout`).
 * Import wizard + listing detail: `AppShell` → `WorkflowPageLayout` → page — both own a Beam workflow
 * layout (`StepperLayout` / `FocusedFormLayout`), which brings its own header and CTAs and gets no navbar.
 * Other detail pages: `AppShell` → `GlobalNavLayout` → `ScrollableParentLayout` → page (legacy `PageHeader`).
 *
 * The catalog, import and listing pages use Beam layouts that assume the document scrolls, so they cannot
 * nest under `GlobalNavLayout`/`ScrollableParentLayout` — see `src/routing/README.md`. The remaining
 * detail pages still use the legacy chrome, hence the split tree.
 *
 * Static paths (`add`, `merge`, `install-tasks`) and the nested `:variantId/cost` path are registered
 * before the bare `:listingId` details route.
 */
export const materialCatalogRoutes: RouteObject = {
  path: materialCatalogPaths.materialsCatalogRoute.path,
  Component: AppShell,
  children: [
    {
      Component: GlobalNavLayout,
      children: [
        {
          Component: ScrollableParentLayout,
          children: [
            { path: materialCatalogPaths.materialCreateRoute.path, Component: MaterialPage },
            { path: materialCatalogPaths.materialMergeRoute.path, Component: MergeMaterialVariantsPage },
            { path: materialCatalogPaths.installTasksRoute.path, Component: InstallTasksPage },
            { path: materialCatalogPaths.materialCostRoute.path, Component: MaterialCostPage },
          ],
        },
      ],
    },
    {
      Component: WorkflowPageLayout,
      children: [
        { path: materialCatalogPaths.materialImportRoute.path, Component: MaterialImportPage },
        { path: materialCatalogPaths.materialDetailsRoute.path, Component: MaterialListingPage },
      ],
    },
    { Component: BeamNavbarLayout, children: [{ index: true, Component: MaterialCatalogPage }] },
    { path: "*", Component: NotFound },
  ],
};
